import { Link } from "react-router-dom";
import { mainURL } from "../utils/common";


export const LeftSocialMediaIconUI = () => {
  return (
    <div
      className="social-media wow slideInDown"
      style={{ visibility: "visible", animationName: "slideInDown" }}
    >
      <div className="facebook" rel="ebInfo" title="facebook">
        <a
          href="https://www.facebook.com/KolkataMunicipalCorporation.official"
          target="_blank" rel="noreferrer"
        >
          <img src="assets/img/face-book-1.png" alt="alt" />
        </a>
      </div>
      <div className="twitter" rel="ebInfo" title="Twitter">
        <a href="https://twitter.com/kmc_kolkata" target="_blank" rel="noreferrer">
          <img src="assets/img/twitter1.png" alt="alt" />
        </a>
      </div>
      {/* <div className="support" rel="ebInfo" title="KMC Support">
        <a href={`${mainURL}/KMCPortal/jsp/ContactDept.jsp`} target="_blank" rel="noreferrer">
          <img src="assets/img/support.png" alt="alt" />
        </a>
      </div> */}
      {/* <div className="whatsapp" rel="ebInfo" title="Whatsapp">
        <Link to="/Wathsapp" target="_blank">
          <img src="assets/img/social-media.png" alt="alt" />
        </Link>
      </div> */}
    </div>
  );
};
